import { LitElement } from './-global.min.js'

export class HHProductMedia extends LitElement {
  static properties = {
    id: {
      type: String,
      reflect: true,
      attribute: 'id'
    },
  }

  constructor() {
    super()
    this.id = ''
  }

  firstUpdated() {
    this.initializeCarousel()

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', () => this.initializeCarousel())
    }
  }

  initializeCarousel() {
    const thumnailCarousel = new Swiper(`.js-thumbnail-carousel-${this.id}`, {
      slidesPerView: 4,
      spaceBetween: 3,
      mouseDragging: true,
      navigation: {
        nextEl: `.js-thumbnail-wrapper-${this.id} .swiper-button-next`,
        prevEl: `.js-thumbnail-wrapper-${this.id} .swiper-button-prev`,
      },
      direction: 'vertical',
      keyboard: {
        enabled: true
      },
      mousewheel: {
        forceToAxis: true
      }
    })

    const mediaCarousel = new Swiper(`.js-media-carousel-${this.id}`, {
      slidesPerView: 1,
      pagination: {
        enabled: true,
        el: `.js-media-carousel-${this.id} .swiper-pagination`,
        clickable: true
      },
      effect: 'creative',
      breakpoints: {
        990: {
          pagination: {
            enabled: false
          }
        }
      },
      mouseDragging: true,
      mousewheel: {
        forceToAxis: true
      },
      thumbs: {
        swiper: thumnailCarousel,
      },
      keyboard: {
        enabled: true
      },
      on: {
        slideChange: function () {
          // Pause all videos when changing slides
          const videos = this.el.querySelectorAll(`hh-media-chrome-video`);
          for (const video of videos) {
            video.pause()
          }
          // Play video on active slide
          const activeIndex = this.activeIndex;
          const activeSlide = this.el.querySelectorAll('.swiper-slide')[activeIndex];
          if (!activeSlide) return;
          const activeSlideVideo = activeSlide.querySelector('hh-media-chrome-video');
          if (!activeSlideVideo) return;
          activeSlideVideo.play();
        },
      }
    })

    const thumbnailCards = thumnailCarousel.slidesEl.querySelectorAll('.swiper-slide')
    thumbnailCards.forEach((slide) => {
      slide.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          mediaCarousel.slideTo(slide.dataset.position - 1)
        }
      })
    })
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('hh-product-media', HHProductMedia)
